import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore } from '@utils/react';

const initialState = {
  showPanel: false,
  showCreateDrawer: false,
  showShareDrawer: false
};
const slice = createSlice({
  name: "feature/course-builder",
  initialState,
  reducers: {
    selectCourseById(state, action) {
      state.selectedCourseId = action.payload;
    },
    togglePanel(state, action) {
      if (typeof action.payload !== "undefined") {
        state.showPanel = action.payload;
      } else {
        state.showPanel = !state.showPanel;
      }
    },
    toggleCreateDrawer(state, action) {
      if (typeof action.payload !== "undefined") {
        state.showCreateDrawer = action.payload;
      } else {
        state.showCreateDrawer = !state.showCreateDrawer;
      }
    },
    toggleShareDrawer(state, action) {
      if (typeof action.payload !== "undefined") {
        state.showShareDrawer = action.payload;
      } else {
        state.showShareDrawer = !state.showShareDrawer;
      }
    }
  }
});
const courseBuilderStore = createIndependentStore(slice);
const useCourseBuilder = courseBuilderStore.useSelector;

export { courseBuilderStore, slice, useCourseBuilder };
//# sourceMappingURL=store.js.map
